import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import "./Button.scss";
import { forwardRef } from "react";

const Button = forwardRef(({ classNames, onClick, type, disabled, children, buttonClass }, ref) => {
	return (
		<button
			ref={ref}
			type={type}
			className={clsx("button", buttonClass, ...classNames)}
			onClick={onClick}
			disabled={disabled}
		>
			{children}
		</button>
	);
});

Button.propTypes = {
	classNames: PropTypes.arrayOf(PropTypes.string),
	onClick: PropTypes.func,
	type: PropTypes.string,
	disabled: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.element]).isRequired,
	buttonClass: PropTypes.string,
};

Button.defaultProps = {
	classNames: [],
	type: "button",
	disabled: false,
	buttonClass: "",
	onClick: () => {},
};

export default Button;
